import API from '../../../../../helpers/request/api';

const api = () => new API();

const getList = (postId) => {
  const query = {
    query: `{
      comments_by_post_id(post_id: ${postId} ) {
        id
        content
        created_at
        approved
        user {
          name
          photo
        }
        admin_user {
          name
          photo
        }
        comments_with_pending_approve {
          id
          content
          created_at
          approved
          user {
            name
            photo
          }
          admin_user {
            name
            photo
          }
          comments_with_pending_approve {
            id
            content
            created_at
            approved
            user {
              name
              photo
            }
            admin_user {
              name
              photo
            }
          }
        }
      }
    }`,
  };

  return api().get(query);
};

const create = (postId, comment, commentId, projectId) => {
  let safeCommentId = commentId;

  if (!safeCommentId) {
    safeCommentId = null;
  }

  const query = {
    variables: { comment },
    query: `mutation createUserComment($comment: String!) {
      createUserComment(
        input: {
          post_id: ${postId}
          comment_id: ${safeCommentId}
          content: $comment
          project_id: ${projectId}
        }
      ) {
        comment {
          id
          content
          created_at
          post_id
          comment_id
          user_id
        }
        message
      }
    }`,
  };

  return api().get(query);
};

const destroy = (id) => {
  const query = {
    query: `mutation destroyComment {
      destroyComment(
        input: {
          id: ${id}
        }
      ) {
        message
      }
    }`,
  };

  return api().get(query);
};

export default {
  getList,
  create,
  destroy,
};



// WEBPACK FOOTER //
// ./src/screens/Class/Details/Comments/queries/comments.js